module.exports = __webpack_public_path__ + "static/media/road.3dc1b324.jpg";